
import Vue from "vue";
import {Component, Prop, Watch} from 'vue-property-decorator';
import {Location} from '@clients/myTrips';
import MapboxConfig from '@/config/MapboxConfig';
import IconMapPoint from '@components/icons/icon-map-point.svg'
import { MglMap } from 'vue-mapbox';
import MglGeocoderControl from 'vue-mapbox-geocoder'

@Component({
  name: 'ZoneMapbox',
  components: {
    MglMap,
    MglGeocoderControl,
    IconMapPoint
  }
})

export default class ZoneMapbox extends Vue {
  @Prop({ required: true })
  private value: Location;

  @Prop({ required: true })
  private radius: number;

  @Prop({ default: false })
  private readonly: boolean;

  private component = null;

  // Preventing unexpected behaviour after map was dragged by user
  private preventLocationChange = false;
  private preventTwiceLocationJump = false;

  private radiusToZoomMapping = {
    20: 16.7,
    50: 15.2,
    100: 14.2,
    200: 13.2,
    300: 12.7,
    400: 12.1
  }

  get zoom() {
    return this.radiusToZoomMapping[this.radius]
  }

  get center() {
    return [this.value.longitude, this.value.latitude];
  }

  get mapboxAccessToken() {
    return MapboxConfig.accessToken;
  }

  private onMapLoad(event) {
    this.component = event.component;
  }

  private handleCenterUpdate({ lat, lng }) {
    if (this.preventLocationChange) {
      this.preventLocationChange = false;
    } else if (this.value.latitude !== lat && this.value.longitude !== lng) {
      this.preventTwiceLocationJump = true;
      this.$emit('input', { latitude: lat, longitude: lng } );
    }
  }

  @Watch('value')
  private onValueChange(newLocation: Location) {
    if (this.component) {
      if (this.component.map.isMoving() && !this.preventTwiceLocationJump) {
        this.preventLocationChange = true;
      }
      if (this.preventTwiceLocationJump) {
        this.preventTwiceLocationJump = false;
      } else {
        this.component.actions.jumpTo({
          center: [newLocation.longitude, newLocation.latitude],
          zoom: this.zoom
        })
      }
    }
  }

}
